import a from "./internal/_curry2.mjs";
import o from "./paths.mjs";
var u = /* @__PURE__ */ a(function(r, t) {
  return o([r], t)[0];
});
export {
  u as default
};
